import { render, staticRenderFns } from "./TopBarFlat.vue?vue&type=template&id=4012de77&"
import script from "./TopBarFlat.vue?vue&type=script&lang=js&"
export * from "./TopBarFlat.vue?vue&type=script&lang=js&"
import style0 from "./TopBarFlat.vue?vue&type=style&index=0&id=4012de77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports